import React, { useEffect } from 'react'
import { Header } from '../../components/navigation/header/Header'
import { Demo } from '../../components/navigation/demo/Demo'
import { Footer } from '../../components/navigation/footer/Footer'
import { About } from '../../components/about/About'
import { FAQList } from '../../components/faq/list/FAQList.js'
import { Summary } from '../../components/summary/Summary'
import { BankList as Updatebox } from '../../components/updatebox/bank/list/BankList'
import {
	MarketingModuleDatas,
	MarketingSection
} from '../../components/marketing/section/MarketingSection'
import { VegaHeading } from '../../components/vega/heading/Heading'
import style from './tracker.module.scss'
import { useTranslation } from 'react-i18next'
import { SkeletonTheme } from 'react-loading-skeleton'
import { VegaCard } from '../../components/vega/card/Card'

export const Tracker = ({ headerAnimate, isDemo }) => {
	const { t } = useTranslation()

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

	return (
		<div className={style.tracker}>
			<SkeletonTheme color={'#152f48'} highlightColor={'#1b3b58'}>
				<div className={style.top}>
					{isDemo && <Demo />}
					<Header isAnimate={headerAnimate} />
					<Summary />
				</div>
			</SkeletonTheme>
			<div className={style.middle}>
				<div className={style.container}>
					<VegaHeading className={style.heading} tag={'h4'} label={t('historyTitle')} />
					<div className={style.boxes}>
						<Updatebox className={style.updatebox} />
						<div className={style.rightPane}>
							<VegaCard className={style.marketingCard}>
								<MarketingSection {...MarketingModuleDatas} />
							</VegaCard>
						</div>
					</div>
				</div>
			</div>
			<FAQList />
			<About />
			<Footer />
		</div>
	)
}
